import axios from "axios";
import {environment} from "../environment";

export async function loginToNewShop() {

    const bodyOfRequest = {
        "grant_type": "client_credentials",
        "client_id": "SWIARGFRANDRCXRVENVLRZB2RA",
        "client_secret": "M1k4ejJpcjhjOUt5V0xKM05yRHI4a0NkOFZWZjBCRUswQzBkUjk"
    }

    const sendTheRequest = await axios.post(`${environment.newBackendURL}oauth/token`, bodyOfRequest, {}).then((res) => {
        return res.data.access_token;
    })

    return sendTheRequest;

}
